/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export enum TouchplanPlatform {
	Desktop = 'desktop',
	Mobile = 'mobile',
}
